import React, { memo, useMemo } from 'react'
import { Box, useTheme } from '@mui/material'

/**
 * Static placeholder for the chart symbol / status-line control bar (pane-meta-container).
 * Matches the absolute overlay position used by SeriesMetadataDisplay.
 */
const ChartMetadataBarPlaceholder = () => {
    const theme = useTheme()
    const isDark = theme.palette.mode === 'dark'

    const colors = useMemo(
        () => ({
            fill: isDark ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.09)',
            muted: isDark ? 'rgba(255, 255, 255, 0.07)' : 'rgba(0, 0, 0, 0.06)'
        }),
        [isDark]
    )

    return (
        <Box
            className="pane-meta-container"
            sx={{
                position: 'absolute',
                top: '4px',
                left: '6px',
                zIndex: 6,
                pointerEvents: 'none',
                display: 'flex',
                flexDirection: 'column',
                gap: 0.5,
                maxWidth: 'calc(100% - 12px)'
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 0.5 }}>
                <Box
                    sx={{
                        width: 22,
                        height: 22,
                        borderRadius: 0.5,
                        bgcolor: colors.muted,
                        border: 1,
                        borderColor: 'divider',
                        flexShrink: 0
                    }}
                />
                <Box sx={{ width: 92, height: 22, borderRadius: 0.5, bgcolor: colors.fill, flexShrink: 0 }} />
                <Box sx={{ width: 40, height: 20, borderRadius: 0.5, bgcolor: colors.muted, flexShrink: 0 }} />
                <Box sx={{ width: 36, height: 20, borderRadius: 0.5, bgcolor: colors.muted, flexShrink: 0 }} />
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 1, pl: 0.25 }}>
                {[48, 40, 44, 52, 36, 56].map((width, index) => (
                    <Box
                        key={index}
                        sx={{
                            width,
                            height: 10,
                            borderRadius: 0.5,
                            bgcolor: colors.muted,
                            flexShrink: 0
                        }}
                    />
                ))}
            </Box>
        </Box>
    )
}

export default memo(ChartMetadataBarPlaceholder)
